import { Suspense } from "react";

import { ChunkLoadErrorBoundary, lazyChunk } from "@shared/ChunkLoadErrorBoundary";
import { LoadingBox } from "@shared/Loading";

import { useStyles } from "./AddDeviceModal.styles";
import type { Props as QrScannerProps } from "./QrScanner";

export const importScanner = () => import("./QrScanner").then((module) => ({ default: module.QrScanner }));

const LazyQrScanner = lazyChunk(importScanner);

type Props = QrScannerProps & {
    onLoadError: () => void;
};

export const QrScanner = ({ onLoadError, ...props }: Props) => {
    const { classes } = useStyles();

    return (
        <ChunkLoadErrorBoundary onError={onLoadError}>
            <Suspense fallback={<LoadingBox className={classes.scannerLoading} />}>
                <LazyQrScanner {...props} />
            </Suspense>
        </ChunkLoadErrorBoundary>
    );
};
